import { useAuth } from "@/lib/auth";
import { SavedSignatureCard } from "@/components/saved-signature-card";
import { UserCircle } from "lucide-react";

/**
 * Profile page — currently focused on the saved-signature panel that
 * powers TCEQ-20700 (and any other jurisdiction form's tester signature
 * line). When a signature is saved here, the form-fill engine will
 * automatically use it on every backflow test the tech submits without
 * forcing them to re-sign at the end of each workflow.
 */
export default function ProfilePage() {
    const { user } = useAuth();

    return (
        <div className="space-y-6 max-w-2xl mx-auto">
            <div>
                <h1 className="text-2xl font-black tracking-tight text-shell-foreground flex items-center gap-2">
                    <UserCircle className="h-6 w-6" /> My Profile
                </h1>
                <p className="text-shell-foreground/80 text-sm mt-1">
                    {user?.display_name ?? "Personal preferences"} — settings here only
                    affect your own account.
                </p>
            </div>

            <SavedSignatureCard />
        </div>
    );
}
